import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";

/**
* @class Weekday
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.weekdays[0];
* const contactInfo = new Weekday(record);
* @property {NUMBER} _id - The id of the weekday.
* @property {STRING} _value - The value of the weekday, like "Central Standard Time"
*/
export default class Weekday extends BCMSRecord {
    _id
    _description
    _descriptionLowercase
    _descriptionAbbrv

    constructor (record){     
      super(record) 
    }
  }
  Weekday.define({
    "recordType":"weekdays",
    "recordIDProp":"id",
    "className" : "Weekday",
    "recordProperties":[
      /** 
       * @name id
       * @instance
       * @property get {NUMBER} - gets the id of the Weekday
       * @property set {NUMBER} - sets the id of the Weekday
       * @memberof Weekday
       */
      BCMSRecordProperty.mapToString("id","_id"),

        /** 
       * @name description
       * @instance
       * @property get {STRING} - gets the value of the Weekday, like "Central Standard Time"
       * @property set {STRING} - sets the value of the Weekday, like "Central Standard Time"
       * @memberof Weekday
       */
        BCMSRecordProperty.mapToString("description","_description"),

      /** 
       * @name descriptionLowercase
       * @instance
       * @property get {STRING} - gets the value of the Weekday, like "Central Standard Time"
       * @property set {STRING} - sets the value of the Weekday, like "Central Standard Time"
       * @memberof Weekday
       */
      BCMSRecordProperty.mapToString("descriptionLowercase","_descriptionLowercase"),

      /** 
       * @name descriptionAbbrv
       * @instance
       * @property get {STRING} - gets the value of the Weekday, like "Central Standard Time"
       * @property set {STRING} - sets the value of the Weekday, like "Central Standard Time"
       * @memberof Weekday
       */
      BCMSRecordProperty.mapToString("descriptionAbbrv","_descriptionAbbrv"),
    ]  
})




